import api from '../../config/axios';

// ============================================================================
// QUIZ SERVICE API
// All endpoints for quiz-related operations (Student & Teacher perspectives)
// ============================================================================

export const quizService = {
  // ============================================================================
  // STUDENT QUIZ API
  // ============================================================================

  /**
   * Get quiz data for student
   * GET /api/quizzes/:quizId
   * Purpose: Fetch quiz questions and metadata for student to take the quiz
   * @param {number} quizId - ID of the quiz
   * @returns {Promise} Response with quiz data including questions
   */
  getQuiz: async (quizId) => {
    const response = await api.get(`/quizzes/${quizId}`);
    return response.data;
  },

  /**
   * Submit quiz answers
   * POST /api/quizzes/:quizId/submit
   * Purpose: Submit student's answers and calculate score
   * @param {number} quizId - ID of the quiz
   * @param {Object} submissionData - Answers and time spent {answers, timeSpentSeconds}
   * @returns {Promise} Response with quiz result including score
   */
  submitQuiz: async (quizId, submissionData) => {
    const response = await api.post(`/quizzes/${quizId}/submit`, submissionData);
    return response.data;
  },

  /**
   * Load quiz attempt review
   * GET /api/quizzes/:quizId/attempts/:attemptId/review
   * Purpose: Get detailed review of quiz attempt with correct answers
   * @param {number} quizId - ID of the quiz
   * @param {number} attemptId - ID of the attempt
   * @returns {Promise} Response with attempt review data
   */
  loadReview: async (quizId, attemptId) => {
    const response = await api.get(`/quizzes/${quizId}/attempts/${attemptId}/review`);
    return response.data;
  },

  /**
   * Check if student can retake quiz
   * GET /api/quizzes/:quizId/can-retake
   * Purpose: Check retake eligibility based on max attempts
   * @param {number} quizId - ID of the quiz
   * @returns {Promise} Response with retake status and attempt info
   */
  checkCanRetake: async (quizId) => {
    const response = await api.get(`/quizzes/${quizId}/can-retake`);
    return response.data;
  },

  /**
   * Get lesson navigation (next/previous lesson)
   * GET /api/lessons/:lessonId
   * Purpose: Fetch lesson details including navigation to next/previous lesson
   * @param {number} lessonId - ID of the lesson
   * @returns {Promise} Response with lesson navigation data
   */
  getLessonNavigation: async (lessonId) => {
    const response = await api.get(`/lessons/${lessonId}`);
    return response.data;
  }
};

export default quizService;
